import React, { useState } from "react";
import "./component.css";
import { FiSearch } from "react-icons/fi";
import { FaMapMarkerAlt } from "react-icons/fa";
import { HiOutlineMicrophone } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = (route) => {
    setIsOpen(false);
    navigate(`/${route}`);
  };

  return (
    <div
      className="navbar-bg-wrapper"
      style={{
        backgroundImage: `url('/image/foodie.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        padding: "20px 0",
        minHeight: "100px",
        color: "#fff",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.85)",
          zIndex: 1,
        }}
      />

      {/* Content */}
      <nav
        className="navbar-mobile-only"
        style={{ position: "relative", zIndex: 2 }}
      >
        <div className="navbar-mobile">
          {/* Top Row */}
          <div className="mobile-top d-flex justify-content-between align-items-start">
            {/* Left: Location & Address */}
            <div className="mobile-location-group">
              <div className="mobile-location d-flex align-items-center">
                <FaMapMarkerAlt className="mobile-icon" />
                <span className="fw-bold">And work Co wo...</span>
                <span className="down-arrow">▾</span>
              </div>
              <div className="mobile-address">
                PLOT NO 5B, SECTOR 15A, FI...
              </div>
            </div>

            {/* Right: Toggle & Avatar */}
            <div className="d-flex align-items-center gap-2">
              <div className="veg-toggle text-white d-flex align-items-center">
                VEG MODE
                <input type="checkbox" />
              </div>
              <div className="mobile-avatar" onClick={toggleSidebar}>
                K
              </div>
            </div>
          </div>

          {/* Search Bar Row */}
          <div className="mobile-search-bar">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder='Search "tea"'
              className="search-input text-white"
            />
            <HiOutlineMicrophone className="mic-icon" />
          </div>

          {/* Sidebar Overlay */}
          <div
            className={`sidebar-overlay ${isOpen ? "show" : ""}`}
            onClick={toggleSidebar}
          />

          {/* Sidebar */}
          <div className={`sidebar ${isOpen ? "open" : ""}`}>
            <div className="sidebar-header">Welcome, Komal</div>
            <ul className="sidebar-menu">
              <li onClick={() => handleNavigate("profile")}>Profile</li>
              <li onClick={() => handleNavigate("orders")}>Orders</li>
              <li onClick={() => handleNavigate("settings")}>Settings</li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
